import { render, staticRenderFns } from "./ProviderInfo.vue?vue&type=template&id=66a365ee&scoped=true"
import script from "./ProviderInfo.vue?vue&type=script&lang=js"
export * from "./ProviderInfo.vue?vue&type=script&lang=js"
import style0 from "./ProviderInfo.vue?vue&type=style&index=0&id=66a365ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a365ee",
  null
  
)

export default component.exports